import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

export const tableSlotRecipe = defineSlotRecipe({
  slots: tableAnatomy.keys(),
  base: {
    columnHeader: {
      px: 2,
      py: 2,
      borderColor: '{colors.neutral.100}',
    },
    cell: {
      px: 2,
      py: 2,
      borderColor: '{colors.neutral.100}',
    },
  },
  variants: {
    interactive: {
      true: {
        body: {
          '& tr': {
            _hover: {
              bg: 'neutral.50',
            },
          },
        },
      },
    },
  },
});
